<template>
	<div class="card-compare__field">
		<div v-if="attrib.bool" class="text-center">
			<span class="bool-icon mr-2 text-responsive text-center">
				<font-awesome-icon
					:icon="attrib.value ? 'check-circle' : 'times-circle'"
					:class="attrib.value ? 'text-success' : 'text-danger'"
				/>
			</span>
		</div>
		<div v-else-if="attrib.justImg">
			<b-img :src="imgPath + attrib.img" fluid />
		</div>
		<div v-else class="card-compare__field__value">
					<div class="card-compare__field__value__text">{{ attrib.valueLabel }}</div>
					<b-progress class="card-compare__field__value__progress" :max="1" height="0.75rem">
						<b-progress-bar
							:value="attrib.value / attrib.maxValue"
							:variant="
								progressVariant(
									attrib.value,
									attrib.maxValue,
									attrib.lessIsMore
								)
							"
						></b-progress-bar>
					</b-progress>
		</div>
	</div>
</template>
<script>
export default {
	props: ["attrib", "imgPath"],
	methods: {
		isStartMiddleEnd: function (value, max) {
			if (value < max * 0.33) {
				return 1;
			} else if (value > max * 0.66) {
				return 3;
			} else {
				return 2;
			}
		},
		progressVariant: function (value, max, lessIsMore) {
			let whichThird = this.isStartMiddleEnd(value, max);

			if (whichThird == 1) {
				return lessIsMore ? "success" : "danger";
			} else if (whichThird == 3) {
				return lessIsMore ? "danger" : "success";
			} else {
				return "warning";
			}
		},
		frontIcon: function (value, max, lessIsMore) {
			let whichThird = this.isStartMiddleEnd(value, max);

			if (whichThird == 1) {
				return lessIsMore ? "success" : "danger";
			} else if (whichThird == 2) {
				return "warning";
			} else {
				return "muted";
			}
		},
		backIcon: function (value, max, lessIsMore) {
			let whichThird = this.isStartMiddleEnd(value, max);

			if (whichThird == 3) {
				return lessIsMore ? "danger" : "success";
			} else if (whichThird == 2) {
				return "warning";
			} else {
				return "muted";
			}
		},
	},
};
</script>
<style>
.bool-text,
.label-text {
	font-weight: bold;
}
.bool-icon {
	font-size: 1.5rem;
}

.bool-success,
.bool-danger,
.bool-warning {
	border-width: 4px !important;
}

.bool-success {
	border-color: #2eca8b !important ;
}
.bool-danger {
	border-color: #e43f52 !important;
}
.bool-warning {
	border-color: #f17425 !important;
}
.attrib-bg {
	background: #f3f3f3;
}

.bv-avatar {
	width: 5rem;
	height: 5rem;
}

@media (min-width: 300px) and (max-width: 768px) {
	.bv-avatar {
		width: 3rem !important;
		height: 3rem !important;
	}

	.text-responsive {
		font-size: calc(1vw + 1vh);
	}
}
</style>
